<script>
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";

  // Import Swiper styles
  import "swiper/css";
  import "swiper/css/navigation";
  import "swiper/css/pagination";
  import "swiper/css/scrollbar";
  import "swiper/css/autoplay";
  import Categories from "./categories.svelte";

  let discounts = [];
  let homeposts = [];
  let set_data = [];

  onMount(async function () {
    window.scrollTo(0, 0);
    const user = localStorage.getItem("us");

    if (user === null || user === "") {
      navigate("/login");
    } else {
      const response = await fetch(api_url);
      const data = await response.json();
      // console.log(data);
      if (data != null) {
        const fildis = data.filter((n) => n);
        // const header_data = response.headers;
        // set_data = header_data.get("arun");
        // console.log(fildis);
        discounts = fildis;
      }
      const home6response = await fetch(home6_api_url);
      const homepostdata = await home6response.json();
      const filhome = homepostdata.filter((n) => n);
      // https://stackoverflow.com/questions/281264/remove-empty-elements-from-an-array-in-javascript
      if (filhome != null) {
        homeposts = filhome;
        // console.log(filhome);
      }
    }
  });

  const API_END_POINT = END_POINT;
  const api_url = API_END_POINT + "discounts.php";
  const home6_api_url = API_END_POINT + "home6.php";
  let user_color_mode;

  if (
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  ) {
    user_color_mode = "dark";
  } else {
    user_color_mode = "light";
  }

  function remove_placeholder() {
    const nodeList = document.querySelectorAll(".placeholder");
    for (var i = 0; i < nodeList.length; i++) {
      nodeList[i].classList.remove("placeholder");
    }
  }
</script>

<svelte:head>
  <!-- Primary Meta Tags -->
  <title>Veerun Fashions | Buy All Mens Fashion Products Online</title>
  <meta
    name="title"
    content="Veerun Fashions | Buy All Mens Fashion Products Online"
  />
  <meta name="description" content="Mens Fashion Store at Affordable Price" />

  <!-- Open Graph / Facebook -->
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://app.veeranfashions.com/" />
  <meta
    property="og:title"
    content="Veerun Fashions | Buy All Mens Fashion Products Online"
  />
  <meta
    property="og:description"
    content="Mens Fashion Store at Affordable Price"
  />
  <meta
    property="og:image"
    content="https://cdn.statically.io/og/VeeranFashions.com.jpg"
  />

  <!-- Twitter -->
  <meta property="twitter:card" content="summary_large_image" />
  <meta property="twitter:url" content="https://app.veeranfashions.com/" />
  <meta
    property="twitter:title"
    content="Veerun Fashions | Buy All Mens Fashion Products Online"
  />
  <meta
    property="twitter:description"
    content="Mens Fashion Store at Affordable Price"
  />
  <meta
    property="twitter:image"
    content="https://cdn.statically.io/og/VeeranFashions.com.jpg"
  />
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list">
            <li class="list-item">
              <div class="logo-img" />
              <!-- <a href="intent://#Intent;package=com.google.zxing.client.android;S.browser_fallback_url=https://google.com;end"> Take a QR code </a>
              <a href="intent://#Intent;package=org.telegram.messenger;S.browser_fallback_url=https://t.me/TamilYogi_Downloader_Bot;end"> Telegram </a>
              <a href="intent://#Intent;package=com.mxtech.videoplayer.ad;S.title=New%20title;S.browser_fallback_url=http://devimages.apple.com/iphone/samples/bipbop/bipbopall.m3u8;end"> Mx player </a> -->
            </li>
            <li class="list-item">
              <ul class="list-child">
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="/cart"
                    area-label="cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-cart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                      />
                    </svg>
                  </Link>
                </li>
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="/profile-settings"
                    area-label="profile-settings"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-person-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- ...:::Start Hero Slider Section:::... -->
  <div class="hero-section section-gap-top-25">
    <div class="container">
      <!-- Start Hero Area -->
      <div class="hero-area hero-area--style-1 hero-slider-active">
        <!-- Slider main container -->
        <Swiper
          class="placeholder-glow"
          modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
          loop={true}
          loopFillGroupWithBlank={true}
          spaceBetween={90}
          pagination={{
            clickable: true,
            el: ".swiper-pagination",
            type: "bullets",
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            loopPreventsSlide: false,
          }}
        >
          <!-- Slides -->

          {#each discounts as discount}
            <SwiperSlide>
              <Link to="/{discount.link}">
                <div class="hero-singel-slide">
                  <div class="hero-bg">
                    {#if discount.image.includes("mp4")}
                      <!-- svelte-ignore a11y-media-has-caption -->
                      <video
                        width="370"
                        height="294"
                        class="placeholder img-full"
                        autoplay
                        muted
                        loop
                      >
                        <source src={discount.image} type="video/mp4" />
                      </video>
                    {:else}
                      <img
                        width="370"
                        height="294"
                        class="placeholder img-full"
                        src={discount.image}
                        alt="Veeran Fashion"
                        on:load={remove_placeholder}
                      />
                    {/if}
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          {/each}
        </Swiper>
        <!-- If we need pagination -->
        <div class="swiper-pagination" />
      </div>
      <!-- End Hero Area -->
    </div>
  </div>
  <!-- ...:::End Hero Slider Section:::... -->

  <!-- ...:::Start Catagories - 1 Section:::... -->
  <div class="catagories-section section-gap-top-50">
    <div class="container">
      <Categories />

      <div class="title-content">
        <h2 class="title">Latest</h2>
        <Link to="/shop" class="view-all">View All</Link>
      </div>
      <div class="catagories-wrapper">
        <div class="catagories-wrapper-content">
          <!-- Start Product Single Item -->
          {#each homeposts as homepost}
            <div
              class="single-product-item product-item--style-3 placeholder-glow"
              style="max-height: 270px;"
            >
              <a href="product/{homepost.no}">
                <picture>
                  <source
                    srcset="https://imagecdn.veeranfashions.com/webp/{homepost.image.replace(
                      'png',
                      'webp'
                    )}"
                    type="image/webp"
                    alt="product"
                  />
                  <source
                    srcset="https://imagecdn.veeranfashions.com/{homepost.image}"
                    type="image/png"
                  />
                  <img
                    class="placeholder img-max-height rounded"
                    src="https://imagecdn.veeranfashions.com/{homepost.image}"
                    alt="product"
                    on:load={remove_placeholder}
                  />
                </picture>
              </a>
              <div class="content text-colored">
                <div class="content--left">
                  <p class="title ellipsis">
                    <Link to="product/{homepost.no}" class="text-secondary"
                      >{homepost.name}</Link
                    >
                  </p>
                  <div class="text-colored fw-bolder">
                    &#8377 <del class="fw-normal text-secondary"
                      >{homepost.original_price}</del
                    >
                    {homepost.price}
                  </div>
                </div>
                <div class="content--right" hidden>
                  <a
                    href="wishlist"
                    aria-label="Wishlist"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-pink-swan btn--bg-white btn--box-shadow"
                    ><i class="icon icon-carce-heart" /></a
                  >
                </div>
              </div>
            </div>
          {/each}
          <!-- ENd Product Single Item -->
        </div>
      </div>
    </div>
  </div>
  <!-- ...:::Start Catagories - 1 Section:::... -->

  <!-- ...:::Start User Event Section:::... -->
  <div class="user-event-section">
    <!-- Start User Event Area -->
    <div class="col pos-relative">
      <div class="user-event-area">
        <div class="nav">
          <Link to="/" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-house-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            <br />
            <h6>Home</h6>
          </Link>
          <Link to="/wishlist" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-heart-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
              />
            </svg>
            <br />
            <h6>Wishlist</h6>
          </Link>
          <Link to="/shop" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-grid-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
              />
            </svg>
            <br />
            <h6>Shop</h6>
          </Link>
          <Link to="/orders" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-box-seam-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003 6.97 2.789ZM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461L10.404 2Z"
              />
            </svg>
            <br />
            <h6>Orders</h6>
          </Link>
          <Link to="/settings" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
              />
            </svg>
            <br />
            <h6>Settings</h6>
          </Link>
        </div>
      </div>
    </div>
    <!-- End User Event Area -->
  </div>
  <!-- ...:::End User Event Section:::... -->

  <footer class="footer-section" />
</main>
